<div class="container p-0">
    <div class="col-10 col-sm-10 col-md-10 col-lg-8 col-xl-8 col-xxl-8 me-auto">
        <h1 class="c11n-text-xl-headline c11n-space-stack-3x">{{ content?.heading }}</h1>
        
        <c11n-internal-callout class="c11n-space-stack-3x" *ngIf="isInternal">
          <p class="c11n-text-md c11n-link--reinforced">
                {{ infowaveBoxContents[0] }} <a
                    c11n-link
                    tabindex="0"
                    class="c11n-link pointer"
                    [variant]="'secondary-reinforced'"
                    [href]="infoWaveUrl"
                    target="_blank">Infowave</a>
                    {{ infowaveBoxContents[1] }}
                </p>
            </c11n-internal-callout>
        
        <div class="review-container" data-cy="review-and-submit-container">
            <p class="c11n-text-md-bold c11n-space-stack-2x">
                {{
                    removeHTMLtags(content?.body)
                        | replaceParam
                        : [
                            ['userName', userName$ | async],
                            ['accessLevelAccess', accessLevel$ | async | lowercase]
                        ]
                }}
            </p>
            <ul role="list" class="review-container__account-list">
                <li>{{ accountName$ | async }}</li>
            </ul>
        </div>
        
        <div *ngIf="hasCoOwner$| async" data-cy="review-and-submit-note">
            <span class="c11n-text-md-bold">{{ jointAccountAccessParts.part1 }}</span>
            <span class="c11n-text-md">{{
                    jointAccountAccessParts.part2
                        | replaceParam
                        : [
                            ['firstName', firstName$ | async],
                            ['firstName', firstName$ | async]
                        ]
                }}</span>
            <span class="c11n-text-md-bold">{{
                    jointAccountAccessParts.part3
                }}</span>
            <span class="c11n-text-md">.</span>
        </div>
    </div>
</div>
